const DEFAULT_LOCALE = "en-GB";
const LANGUAGE_STORAGE_KEY_PREFIX = "amr_portal_lang_";

export default new (class LanguageHelper {
  resolveSupportedLocale = (locale, availableLocales) => {
    if (!locale) return null;
    const exactMatch = availableLocales.find(
      (l) => l.toLowerCase() === locale.toLowerCase()
    );
    if (exactMatch) return exactMatch;
    const languageCode = locale.split(/[-_]/)[0].toLowerCase();
    if (DEFAULT_LOCALE.toLowerCase().startsWith(languageCode + "-"))
      return DEFAULT_LOCALE;
    return (
      availableLocales.find((l) =>
        l.toLowerCase().startsWith(languageCode + "-")
      ) || null
    );
  };

  getStorageKey = (userId) => LANGUAGE_STORAGE_KEY_PREFIX + userId;

  getStoredLocale = (userId) => {
    try {
      return localStorage.getItem(this.getStorageKey(userId));
    } catch {
      return null;
    }
  };

  saveLocale = (userId, locale) => {
    try {
      localStorage.setItem(this.getStorageKey(userId), locale);
    } catch {
      // Storage unavailable: the choice only lasts for the session
    }
  };

  getBrowserLocale = (availableLocales) => {
    const browserLocales = navigator.languages?.length
      ? navigator.languages
      : [navigator.language];
    for (const locale of browserLocales) {
      const supportedLocale = this.resolveSupportedLocale(
        locale,
        availableLocales
      );
      if (supportedLocale) return supportedLocale;
    }
    return null;
  };

  // Priority: user choice (localStorage) > Keycloak token > browser > default
  getInitialLocale = (tokenParsed, availableLocales) =>
    this.resolveSupportedLocale(
      this.getStoredLocale(tokenParsed?.sub),
      availableLocales
    ) ||
    this.resolveSupportedLocale(tokenParsed?.locale, availableLocales) ||
    this.getBrowserLocale(availableLocales) ||
    DEFAULT_LOCALE;
})();
